import React from "react";
import MediaDetailsCard from "./MediaDetailsCard";

const VideoUnitDetailsCard = ({
  orgMedia,
  assignedAdGroupUnit,
  selectedAdUnits = [],
  handleDeleteMedias = () => {},
}) => {
  return (
    <MediaDetailsCard
      orgMedia={orgMedia}
      assignedAdGroupUnit={assignedAdGroupUnit}
      selectedAdUnits={selectedAdUnits}
      handleDeleteMedias={handleDeleteMedias}
      isVideo={true}
    />
  );
};

export default VideoUnitDetailsCard;
